import { FaChevronLeft } from 'react-icons/fa';

interface Props {
  text: string | React.ReactNode;
  image?: string;
  onClick: () => void;
}

const BackHeader = ({ text, image, onClick }: Props) => {
  return (
    <div onClick={onClick}>
      <p
        className={'tw:mb-0 tw:flex tw:cursor-pointer tw:items-center tw:gap-4 tw:px-5 tw:pb-4 tw:text-lg'}
        onClick={onClick}>
        <FaChevronLeft size={12} className='tw:text-body' />
        <span className='tw:inline-flex tw:items-center tw:gap-3 tw:text-body'>
          {image && (
            <img src={image} alt='Back' className='tw:inline-block tw:h-full tw:max-h-[40px] tw:w-auto' />
          )}
          <span className='tw:text-base tw:font-bold'>{text}</span>
        </span>
      </p>
    </div>
  );
};

export default BackHeader;
